<template>
    <DCard
        padding
    >
        <Form
            :errors="errors"
            @form-submitted="submitForm"
        />
    </DCard>
</template>

<script setup>
import { route } from '~@/Composables/route'
import Form from '~@/Components/Settings/BankAccounts/Form.vue'

defineProps({
    errors: {
        type: Object,
        default: () => {
            return {}
        }
    }
})

function submitForm (form) {
    form.post(route('settings.bank-accounts.store'))
}
</script>
